<template>
    <div class="CourseTocIntroEntry">
        <div class="icon">
            <svgicon class="icon-svg" icon="intro_badge" :original="true" />
        </div>

        <div class="informations">
            <h3>{{ $t('label') }}</h3>
            <p class="intro-label">{{ step.title || $t('label') }}</p>
        </div>

        <a class="button-blue" @click="navigate()">Start</a>
    </div>
</template>

<translations>
  label: 'Introduction'
  label_no: 'Introduksjon'
</translations>

<script>
export default {
    props: {
        stepId: {
            type: String,
            default: ''
        },
        courseId: {
            type: String,
            default: ''
        },
        useEllipsis: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        step() {
            return this.$store.state.moduleCourse.steps[this.stepId];
        }
    },
    methods: {
        navigate() {
            this.$router.push({
                name: 'Course-ActivityRedirect',
                params: {
                    courseId: this.courseId,
                    stepId: this.stepId,
                    activityName: 'read'
                }
            });
            this.$emit('action');
        }
    }
};
</script>

<style lang="scss" scoped>
.CourseTocIntroEntry {
    display: flex;
    align-items: center;
    background-color: #fdfdfd;
    padding: 1.2em 18.5px;
    border-radius: 4px;
    box-shadow: 0px 2px 23px 3px rgba(79, 79, 79, 0.1);
    @media (max-width: 530px) {
        padding: 1.2em 8px;
    }
}

.informations {
    padding-right: 20px;
    width: 100%;
    h3 {
        font-size: 22px;
        line-height: 26px;
        margin: 0;
        margin-top: 15px;
        font-weight: 600;
        @media (max-width: 530px) {
            font-size: 16px;
        }
    }
    p {
        font-size: 16px;
        line-height: 22px;
        color: #727272;
        margin-top: 10.5px;
        margin-bottom: 0;
        @media (max-width: 530px) {
            font-size: 14px;
        }
    }
}

.icon {
    min-width: 96px;
    min-height: 96px;
    max-width: 96px;
    max-height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 22px;
    @media (max-width: 530px) {
        min-width: 68px;
        min-height: 68px;
        max-width: 68px;
        max-height: 68px;
    }
}
.icon-svg {
    width: 100%;
    height: 100%;
}
.label {
    font-size: 140%;
    font-weight: 600;
    flex: 1;
}

.icon-arrow {
    $size: 1em;
    width: $size;
    height: $size;
    fill: rgba(black, 0.3);
    margin-right: 1em;
}
</style>
